<template>
	<div>
    <FormUserLocal
			:userEdit="userLocal"
			@changeTypeForm="changeTypeForm"
			v-if="showFormUser"
		></FormUserLocal>

		<v-card>
      <v-card-title>
        {{ userLocal.nome }}
        <v-spacer></v-spacer>
        <v-btn @click="formUser()" color="green darken-2" outlined>
          <v-icon small left>far fa-pencil</v-icon>
          Editar
        </v-btn>
      </v-card-title>
      <v-card-text>
        CPF: {{ userLocal.cpf }}
        <v-divider class="mt-2 mb-2"></v-divider>
        E-mail: {{ userLocal.email }}
        <v-divider class="mt-2 mb-2"></v-divider>
        Telefone: {{ userLocal.telefone }}
      </v-card-text>
    </v-card>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import FormUserLocal from '@/components/admin/FormUserLocal'

export default {
  components: {
    FormUserLocal
  },
	data () {
    return {
      server: 'user',
			archive: false,
      userLocal: {},
      showFormUser: false,
		}
  },
  computed: {
    ...mapState(['user', 'XMLHttpRequest', 'searchUser']),
	},
	created() {
		this.getData()
  },
  watch: {
    searchUser(val) {
			if (val === true) {
				this.getData()
			}
		},
  },
	methods: {
		getData() {
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_one_' + this.server)
			formData.append('user_id', this.user.id)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
          vd.$store.dispatch('searchUser', { value: false })
					if (response.data.error === 0) {
            vd.userLocal = Object.assign({}, response.data.user)
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
    },
    formUser() {
			this.showFormUser = true
			setTimeout(() => {
				this.$store.dispatch('dialogUser', { value: true })
			}, 300)
		},
		changeTypeForm(value) {
			if (value.hideForm == 'user') {
				this.showFormUser = false
			}
		},
	}
}
</script>